const React = require('react');
const Button = require('@andes/button');
const restclient = require('nordic/restclient');
const Play = require('../Images/play');
const { useApiRefContextProvider } = require('../../../../../../providers/apiRefContextProvider');
const { getEventTracker } = require('../../../../../../utils/event-tracker');
const { avoidHeaderEndpointsList, getRequestContentForLiveTest, getQueryParamContent } = require('../../../parser');

const { useState, useEffect } = React;

const LiveTestButton = () => {
  const { i18n, requestParamsData, actualParams, appCredentials, setResponseDataContent } = useApiRefContextProvider();
  const Tracker = getEventTracker();
  const [loading, setLoading] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);

  const request = restclient({
    timeout: 50000,
    baseURL: '/developers/api',
  });

  useEffect(() => {
    const hasRequiredEmptyExample = actualParams?.apiData?.parameters?.some(item => {
      return item.required === true && item.example === '';
    });

    if (hasRequiredEmptyExample) {
      setDisabledButton(true);
    } else {
      setDisabledButton(false);
    }
  }, [actualParams, requestParamsData]);

  const liveTestRun = () => {
    Tracker.send('mpdevelopers/api-ref/live-test-run', actualParams?.apiEndpoint);
    setLoading(true);
    const headersParams = requestParamsData.filter(({ paramIn }) => paramIn === 'header');
    if (!avoidHeaderEndpointsList.includes(actualParams?.apiEndpoint)) {
      headersParams.push({
        name: 'Authorization',
        example: `Bearer ${appCredentials?.access_token}`,
      });
    }

    const headerContent = headersParams.reduce(
      (result, item) => {
        result[item?.name] = item?.example;
        return result;
      },
      {},
    );

    const bodyContent = getRequestContentForLiveTest(requestParamsData);
    const queryStringContent = getQueryParamContent(requestParamsData);
    setResponseDataContent({
      status: 'loading',
      data: {},
    });
    request.post('/live-testing', {
      data: {
        path: actualParams?.apiEndpoint,
        query: queryStringContent,
        body: bodyContent,
        headers: headerContent,
        method: actualParams?.apiMethod,
      } })
      .then((result) => {
        setResponseDataContent({
          status: 'success',
          data: result?.data,
        });
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setResponseDataContent({
          status: 'error',
          data: error?.response?.data,
        });
        setLoading(false);
      });
  };
  return (
    <div className="api-ref-button-run">
      <Button
        onClick={liveTestRun}
        loading={loading}
        disabled={disabledButton}
        size="medium"
      >
        <Play />
        {i18n.gettext('Ejecutar')}
      </Button>
    </div>
  );
};

module.exports = LiveTestButton;
